import React, {useContext, useEffect, useState} from "react";
import {Context} from "../../../../App";
import DB_Chain from "../../../../database/dictionary/chain";
import {useTranslation} from "react-i18next";
import ModalWindow from "../../../modal";
import {Outlet, useLocation, useNavigate} from "react-router-dom";
import {Breadcrumb, Button, Form, Input, message, Select, Space, Spin} from "antd";
import DB_TradePoint from "../../../../database/dictionary/trade-point";
import axios from "axios";
import DB_Branch from "../../../../database/dictionary/branch";
import DB_Geography from "../../../../database/dictionary/geography";
import DB_TradePointsType from "../../../../database/dictionary/trade-point-type";
import {DebounceSelect} from "../../../tech/search_input";
import DB_OrgStructure from "../../../../database/dictionary/org_structures";
import {isNull} from "../../../tech/check_string";
import DB_PayForms from "../../../../database/dictionary/pay-forms";
import DB_PriceLists from "../../../../database/dictionary/price-lists";
import BackButton from "../../../tech/back_button";

const EditTradePoint = () => {
    const {token, setToken} = useContext(Context);
    const {getTradePoint, updateTradePoint} = DB_TradePoint(token);
    const {getActiveBranches} = DB_Branch(token);
    const {getActiveChains} = DB_Chain(token);
    const {getActiveGeography} = DB_Geography(token);
    const {getActiveTradePointsTypes} = DB_TradePointsType(token);
    const {getOrgStructureFilter} = DB_OrgStructure(token);
    const {branchesPayForms} = DB_PayForms(token)
    const {branchesPriceLists} = DB_PriceLists(token)
    const {t} = useTranslation();
    const {errorConnect} = ModalWindow();
    const params = useLocation().state;
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const [wait, setWait] = useState(true);
    const [isLoadSystem, setIsLoadSystem] = useState(true)
    const [branch, setBranch] = useState([]);
    const [chain, setChain] = useState([]);
    const [geography, setGeography] = useState([]);
    const [tradePointType, setTradePointType] = useState([]);
    const [responsiblePerson, setResponsiblePerson] = useState();
    const [payForms, setPayForms] = useState([])
    const [priceLists, setPriceLists] = useState([])




    const openNotificationFailed = (action) => {
        message.error(t('failed'),)
    };



    useEffect(() => {
        window.scroll(0, 0)
        axios.all([
            getActiveTradePointsTypes(),
            getActiveGeography(),
            getActiveChains(),
            branchesPriceLists(),
            branchesPayForms(),
        ])
            .then(axios.spread(( types, geography, chains) => {
                setTradePointType(types.data);
                setGeography(geography.data);
                setChain(chains.data);
                setIsLoadSystem(false);
            }))
            .catch(e => {
                if (e.request.status === 403) {
                    setToken(null)
                } else {
                    errorConnect()
                }
            })
    }, [])

    useEffect(() => {
        // if (!isLoadSystem) {
        if (params.id != null) {
            console.log(params.id)
            getTradePoint(params.id)
                .then(res => {
                    loadForms(res.data.branch_id)
                    form.setFieldsValue({
                        code: res.data['code'],
                        name: res.data['name'],
                        address: res.data['address'],
                        phone: res.data.phone,
                        legal_entity: res.data['legal_entity'],
                        legal_address: res.data['legal_address'],
                        branch_id: res.data.branch,
                        responsible_person: res.data.responsible_person,
                        price_lists: res.data.price_lists,
                        pay_forms: res.data.pay_forms
                    })
                    setResponsiblePerson(res.data.responsible_person_id)
                    if(res.data['chain_id'] != null) {
                        form.setFieldsValue({
                            chain_id: res.data['chain_id']['id'],
                        })
                        if(res.data['chain_id']['status'] === 0){
                            setChain(current => [...current, res.data['chain_id']])
                        }
                    }
                    if(res.data['trade_point_type_id'] != null) {
                        form.setFieldsValue({
                            tradePoint_type_id: res.data['trade_point_type_id']['id'],
                        })
                        if(res.data['trade_point_type_id']['status'] === 0){
                            setTradePointType(current => [...current, res.data['trade_point_type_id']])
                        }
                    }

                    // if(res.data['branch_id']['status'] === 0){
                    //     setBranch(current => [...current, res.data['branch_id']])
                    // }

                    if (res.data['geography_id'] != null) {
                        form.setFieldsValue({
                            geography_id: res.data['geography_id']['id'],
                        })
                        if(res.data['geography_id']['status'] === 0){
                            setGeography(current => [...current, res.data['geography_id']])
                        }
                    }

                    setWait(false);

                })
                .catch(e => {
                    if (e.status === 403) {
                        setToken(null)
                    } else {
                        setWait(false)
                        errorConnect()
                    }
                });
        } else {
            setWait(false);
        }
        // }
        // }, [isLoadSystem])
    }, [])

    const loadForms = (branch_id) => {
        axios.all([
            branchesPayForms(branch_id),
            branchesPriceLists(branch_id)
        ])
            .then(axios.spread(( payFormsLoad, priceListsLoad) => {
                setPriceLists(priceListsLoad.data);
                setPayForms(payFormsLoad.data);
            }))
            .catch(e => {
                if (e.request.status === 403) {
                    setToken(null)
                } else {
                    errorConnect()
                }
            })
    }


    const onFinish = (values) => {
        setWait(true);

        const formData = new FormData();
        formData.append('name', values["name"]);
        formData.append('address', values["address"]);
        formData.append('legal_entity', values["legal_entity"]);
        formData.append('legal_address', values["legal_address"]);
        formData.append('branch_id', values["branch_id"]);
        formData.append('chain_id', values["chain_id"]);
        formData.append('geography_id', values["geography_id"]);
        formData.append('trade_point_type_id', values["tradePoint_type_id"]);
        formData.append('price_lists', values["price_lists"])
        formData.append('pay_forms', values["pay_forms"])
        if (!isNull(values["phone"])) {
            formData.append('phone', values["phone"])
        }
        if (!isNull( responsiblePerson)) {
            formData.append('responsible_person_id', responsiblePerson);
        }
        if (params.id != null) {
            formData.append('id', params.id);
        }


        if (params.id != null) {
            updateTradePoint(formData)
                .then(res => {
                    if (res.status === 200) {
                        // navigate("/trade-points", {replace: true});
                        // window.history.back()
                        navigate(-1)
                    } else {
                        openNotificationFailed(t('updating'))
                    }
                })
                .catch(e => {
                    if (e.request.status === 403) {
                        setToken(null)
                    } else {
                        errorConnect()
                    }
                })
                .finally(() => {
                    setWait(false)
                })
        }

    }


    return (
        <Spin spinning={wait} delay={300}>
            <div className="page">
                <Space
                    style={{
                        width: '100%',
                        justifyContent: 'space-between'
                    }}>
                    <Breadcrumb
                        style={{
                            margin: '15pt 0',
                        }}
                    >
                        <Breadcrumb.Item>
                            <span className={'ant-page-header-heading-title'} style={{paddingLeft:'24px'}}>{t('trade_point')}</span>
                        </Breadcrumb.Item>
                    </Breadcrumb>

                    <Space>
                        <BackButton />
                        <Button shape="round" type="primary" htmlType="submit" form={"form"}>
                            {t('save')}
                        </Button>
                    </Space>
                </Space>

                <Form
                    form={form}
                    labelCol={{span: 8}}
                    wrapperCol={{span: 10}}
                    layout={"vertical"}
                    onFinish={onFinish}
                    autoComplete="off"
                    id={"form"}
                >
                    <Form.Item
                        style={{marginBottom: '10pt'}}
                        name="code"
                        label={t('code_distributor')}
                    >
                        <Input disabled/>
                    </Form.Item>

                    <Form.Item
                        style={{marginBottom: '10pt'}}
                        name="branch_id"
                        label={t('branch')}
                    >
                        <Input disabled/>

                    </Form.Item>


                    <Form.Item
                        style={{marginBottom: '10pt'}}
                        name="name"
                        label={t('name')}
                        rules={[
                            {
                                required: true,
                                message: t('e_input', {input: t('name').toLowerCase()}),
                            },
                        ]}
                        hasFeedback
                    >
                        <Input/>
                    </Form.Item>

                    <Form.Item
                        style={{marginBottom: '10pt'}}
                        name="address"
                        label={t('address')}
                        rules={[
                            {
                                required: true,
                                message: t('e_input', {input: t('address').toLowerCase()}),
                            },
                        ]}
                        hasFeedback
                    >
                        <Input/>
                    </Form.Item>

                    <Form.Item
                        style={{marginBottom: '10pt'}}
                        name="legal_address"
                        label={t('legal_address')}
                        rules={[
                            {
                                required: true,
                                message: t('e_input', {input: t('legal_address').toLowerCase()}),
                            },
                        ]}
                        hasFeedback
                    >
                        <Input/>
                    </Form.Item>

                    <Form.Item
                        style={{marginBottom: '10pt'}}
                        name="legal_entity"
                        label={t('legal_entity')}
                        rules={[
                            {
                                required: true,
                                message: t('e_input', {input: t('legal_entity').toLowerCase()}),
                            },
                        ]}
                        hasFeedback
                    >
                        <Input/>
                    </Form.Item>

                    <Form.Item
                        style={{marginBottom: '10pt'}}
                        name="phone"
                        label={t('phone')}
                    >
                        <Input/>
                    </Form.Item>


                    <Form.Item
                        style={{marginBottom: '10pt'}}
                        name="chain_id"
                        label={t('chain')}
                        rules={[
                            {
                                required: true,
                                message: t('e_select', {input: t('chain').toLowerCase()}),
                            },
                        ]}
                    >
                        <Select
                            showSearch
                            optionFilterProp="name"
                            optionLabelProp="name"
                            allowClear
                        >
                            {chain.map(u =>
                                <Select.Option key={u.id} value={u.id} name={u.name}
                                               disabled={u.status === 0}>{u.name}</Select.Option>
                            )}
                        </Select>
                    </Form.Item>

                    <Form.Item style={{marginBottom: '10pt'}}
                               name="geography_id"
                               label={t('geography')}
                               rules={[
                                   {
                                       required: true,
                                       message: t('e_select', {select: t('geography').toLowerCase()}),
                                   },
                               ]}
                               hasFeedback
                    >
                        <Select
                            showSearch
                            optionFilterProp="name"
                            optionLabelProp="name"
                        >
                            {geography.map(u =>
                                <Select.Option key={u.id} value={u.id} name={u.name}
                                               disabled={u.status === 0}>{u.name}</Select.Option>
                            )}
                        </Select>
                    </Form.Item>

                    <Form.Item style={{marginBottom: '10pt'}}
                               name="tradePoint_type_id"
                               label={t('trade_points_type')}
                               rules={[
                                   {
                                       required: true,
                                       message: t('e_select', {input: t('trade_points_type').toLowerCase()}),
                                   },
                               ]}
                    >
                        <Select
                            showSearch
                            optionFilterProp="name"
                            optionLabelProp="name"
                            allowClear>
                            {tradePointType.map(u =>
                                <Select.Option key={u.id} value={u.id} name={u.name}
                                               disabled={u.status === 0}>{u.name}</Select.Option>
                            )}
                        </Select>
                    </Form.Item>

                    <Form.Item style={{marginBottom: '10pt'}}
                               name="responsible_person"
                               label={t('responsible_person')}
                    >
                        <DebounceSelect
                            // mode="multiple"
                            showSearch
                            fetchOptions={getOrgStructureFilter}
                            // onChange={e => e ? setResponsiblePerson(e.value)}
                            onChange={e => setResponsiblePerson(e ? e.value : -1 )}
                        />
                    </Form.Item>

                    <Form.Item style={{marginBottom: '10pt'}}
                               name="price_lists"
                               label={t('price_lists')}

                    >
                        <Select
                            showSearch
                            optionFilterProp="name"
                            optionLabelProp="name"
                            mode={"multiple"}
                            allowClear>
                            {priceLists.map(u =>
                                <Select.Option key={u.id} value={u.id} name={u.name}>
                                    {u.name}
                                </Select.Option>
                            )}
                        </Select>
                    </Form.Item>

                    <Form.Item style={{marginBottom: '10pt'}}
                               name="pay_forms"
                               label={t('pay_forms')}

                    >
                        <Select
                            showSearch
                            optionFilterProp="name"
                            optionLabelProp="name"
                            mode={"multiple"}
                            allowClear>
                            {payForms.map(u =>
                                <Select.Option key={u.id} value={u.id} name={u.name}>
                                    {u.name}
                                </Select.Option>
                            )}
                        </Select>
                    </Form.Item>

                </Form>
            </div>
            <Outlet/>
        </Spin>
    )
}

export default EditTradePoint;